import { gsap } from 'gsap/dist/gsap';
import { SplitText } from 'gsap/dist/SplitText';
gsap.registerPlugin(SplitText);

const splitHeroText = () => {
	const heroTitles = document.querySelectorAll('.heroSlide-h1');

	const setupSplits = (titles, num) => {
		titles.forEach((title) => {
			if (title.anim) {
				title.anim.progress(1).kill();
				title.split.revert();
			}

			title.split = new SplitText(title, {
				type: 'lines,words,chars',
				linesClass: 'split-line',
			});

			title.anim = gsap.to(title.split.chars, {
				duration: 1.2,
				ease: 'power3.out',
				top: num,
				stagger: 0.01,
			});
		});
	};

	function heroButton() {
		setupSplits(heroTitles, '-150px');
		gsap.to($('.heroSlide-p'), {
			delay: '.6',
			opacity: '1',
			duration: '2',
			ease: 'power4.out',
		});
		gsap.to($('.heroSlide-btn'), {
			delay: '.6',
			opacity: '1',
			duration: '2',
			ease: 'power4.out',
		});
	}

	$(window).on('load', heroButton);

	const innovationHero = document.getElementsByClassName('innovation-hero');
	const innoTitle = document.querySelectorAll('.innovation-hero-h');
	if (innovationHero.length > 0) {
		console.log('here');
		$(window).on('load', function () {
			const tlInnovation = new gsap.timeline();
			tlInnovation
				.to($('.ih-overlay'), 4, {
					backgroundColor: 'rgba(0, 0, 0, 0)',
					ease: 'power4.out',
				})
				.to(
					$('.innovation-hero'),
					4,
					{
						backgroundSize: '100% 100%',
						ease: 'power4.out',
					},
					'-=4'
				)
				.to(
					$('.innovation-hero-p'),
					1,
					{
						opacity: '1',
						ease: 'power4.out',
					},
					'-=3'
				)
				.to(
					$('.innovation-hero-p2'),
					1,
					{
						opacity: '1',
						ease: 'power4.out',
					},
					'-=3'
				)
				.to(
					$('.inno-opener-b'),
					1,
					{
						opacity: '1',
						ease: 'power4.out',
					},
					'-=3'
				)
				.to(
					$('.inno-black-block'),
					1,
					{
						opacity: '1',
						ease: 'power4.out',
					},
					'-=2.5'
				)
				.to(
					$('.inno-anchor'),
					1,
					{
						opacity: '1',
						ease: 'power4.out',
					},
					'-=2.5'
				);
		});
		setTimeout(function () {
			setupSplits(innoTitle, '-150px');
		}, 1500);
	}

	const winterHero = document.querySelectorAll('.winter-hero-h');
	if ($('.wh-overlay')[0]) {
		$(window).on('load', function () {
			const tlWinter = new gsap.timeline();
			tlWinter
				.to($('.wh-overlay'), 3, {
					backgroundColor: 'rgba(0, 0, 0, .4)',
					ease: 'power4.out',
				})
				.to(
					$('.winter-logos, .winter-top-logos, .winter-bottom-logos'),
					2.5,
					{
						opacity: '.7',
						ease: 'power4.out',
					},
					'-=2.5'
				)
				.to(
					$('.winter-hero-p'),
					2,
					{
						opacity: '1',
						ease: 'power4.out',
					},
					'-=0'
				);
			setTimeout(function () {
				setupSplits(winterHero, '-120px');
			}, 1500);
		});
	}
};
export default splitHeroText;
